import { createFileRoute } from "@tanstack/react-router";

import { AdminShell } from "@/components/admin/AdminShell";

export const Route = createFileRoute("/administrator")({
  head: () => ({ meta: [{ title: "Admin · GENRL" }] }),
  component: AdminShell,
});
